import { call, put } from "redux-saga/effects"
import { push } from 'connected-react-router'
import { Modal } from 'antd'
import axios from 'axios'
import config from '../config'

import {  resetAuth } from "../actions/auth"
import { 
    fetchAccountSuccess,fetchAccountFailed,
    updateAccountSuccess,updateAccountFailed,
    updateNewStatusSuccess,updateNewStatusFailed,
    updatePasswordSuccess,updatePasswordFailed
} from "../actions/account"

export function* fetchAccount(action) {
    const url = config.API_URL+"/myaccount"
    try {
        const response = yield axios({
            method: 'get',
            url: url,
        })
        if(response.data.successful){
            yield put(fetchAccountSuccess(response.data.myaccount))
        }
    }catch(error){
        let message = error.message
        let title = "Fetch User Failed"
        let isShowError = true
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
                isShowError = false
            }
        }
        yield put(fetchAccountFailed(message))
        if(isShowError){
            Modal.error({
                title: title,
                content: message,
            })
        }
    }
}

export function* updateAccount(action) {
    const account = action.payload
    const url = config.API_URL+`/myaccount`
    try {
        const { 
            name,
            phone,
            surname,
            image,
            title_id
        } = account

        const formData = new FormData()
        formData.append("name", name)
        formData.append("surname", surname)
        formData.append("phone", phone)
        formData.append("title", title_id)
        if(image !== undefined){
            formData.append("image",image)
        }
        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        if(response.data.successful){
            yield put(updateAccountSuccess(response.data.message))
            yield put(push(`/account`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(updateAccountFailed(message))
    }
}

export function* updateNewStatus(action) {
    const url = config.API_URL + `/myaccount/status`
    
    try {
        const response = yield axios({
            method: 'post',
            url: url,
        })
        if(response.data.successful){
            yield put(updateNewStatusSuccess(response.data.member))
        }
    } catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(updateNewStatusFailed(message))
    }
}

export function* updatePassword(action) {
    const password = action.payload
    const url = config.API_URL+'/changepassword'
    try {
        const response = yield axios({
            method: 'post',
            url: url,
            data: password
        })
        if(response.data.successful){
            yield put(updatePasswordSuccess(response.data.message))
            yield put(push("/account"))
        }
    }catch(error){
        let title = "Change Password Failed"
        let message = error.message
        let isShowError = true
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
                isShowError = false
            }
        }
        yield put(updatePasswordFailed(message))
        if(isShowError){
            Modal.error({
                title: title,
                content: message,
            })
        }
    }
}





